import React, { useRef, useState } from 'react';
import { Clipboard } from 'react-bootstrap-icons';
import { Overlay, Tooltip } from 'react-bootstrap';

/**
 * Dark code panel with a copy button, matching the snippet blocks under
 * CodeSnippets/. Used for the generated key and the docs examples.
 */
const CodeBlock = ({ label, value, testId, copyTestId }) => {
  const target = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <code
      style={{ display: 'block', background: '#000000', borderRadius: '12px' }}
      className="snippet_code"
    >
      <div className="code-title">
        <p className="code-language">{label}</p>
        <button
          type="button"
          className="copy-button-dark"
          ref={target}
          onClick={handleCopyClick}
          data-testid={copyTestId}
          aria-label={`Copy ${label}`}
        >
          <Clipboard size={20} color="#fff" />
        </button>
        <Overlay target={target.current} show={copied} placement="top">
          {(props) => (
            <Tooltip id={`copied-${label}`} {...props}>
              Copied!
            </Tooltip>
          )}
        </Overlay>
      </div>
      <div className="code-text">
        <pre className="api-key-pre" data-testid={testId}>
          {value}
        </pre>
      </div>
    </code>
  );
};

export default CodeBlock;
